import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Dialog, Toast } from '../shared.model';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private dialogSubject = new Subject<any>();
  dialog$ = this.dialogSubject.asObservable();

  private toastSubject = new Subject<any>();
  toast$ = this.toastSubject.asObservable();

  constructor() {}

  openDialog(dialogData: Dialog) {
    this.dialogSubject.next({ type: 'show', data: dialogData });
  }
  hideDialog() {
    this.dialogSubject.next({ type: 'hide' });
  }
  openToast(toastData: Toast) {
    this.toastSubject.next({ type: 'show', data: toastData });
  }
  closeToast() {
    this.toastSubject.next({ type: 'hide' });
  }
}
